// extracted by mini-css-extract-plugin
module.exports = {"reportsCountLabel":"ReportsCountLabel_reportsCountLabel__1uEHb"};